function GetClientAddress() {
  return window.location.href.includes("localhost")
    ? process.env.REACT_APP_CLIENT_LOCAL
    : process.env.REACT_APP_CLIENT_ONLINE;
}

export default GetClientAddress;
